import { useMemo, cloneElement, isValidElement } from 'react';
import { Layout, Space, Typography, theme } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { GearSix } from '@phosphor-icons/react';
import { useSidebar, useSidebarMetadata } from '../contexts';
import { applyInventorySidebarCounts } from '../utility/applyInventorySidebarCounts';
import { WarehouseDropdown } from '../components';
import { UserOrgMenu } from './UserOrgMenu';
import { getPageMeta } from './sidebarMenuUtils';

const { Header } = Layout;
const { useToken } = theme;

function PageIcon({ icon }) {
  if (!isValidElement(icon)) return null;
  return (
    <span style={{ display: 'flex' }}>
      {cloneElement(icon, { size: 20, weight: 'regular' })}
    </span>
  );
}

export function AppHeader({ headerLead = null, headerActions = null }) {
  const { token } = useToken();
  const location = useLocation();
  const { menus } = useSidebar();
  const { inventory } = useSidebarMetadata();

  const menusWithBadges = useMemo(
    () => applyInventorySidebarCounts(menus, inventory),
    [menus, inventory],
  );

  const meta = useMemo(
    () => getPageMeta(menusWithBadges, location.pathname),
    [menusWithBadges, location.pathname],
  );

  const isSettingsPage = location.pathname.startsWith('/app/settings');

  const defaultTitle = (
    <Space size="small" align="center">
      {meta && <PageIcon icon={meta.phosphorIcon} />}
      <Typography.Text strong style={{ fontSize: 14 }}>
        {meta?.label ?? 'Skupreme'}
      </Typography.Text>
    </Space>
  );

  return (
    <Header
      style={{
        background: '#ffffff',
        height: 56,
        lineHeight: 1,
        padding: '0 20px',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          minWidth: 0,
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        {headerLead ?? defaultTitle}
      </div>

      <Space size="middle" align="center">
        {headerActions}
        <WarehouseDropdown />
        {!isSettingsPage && (
          <Link
            to="/app/settings"
            style={{ display: 'flex', alignItems: 'center', color: '#262626' }}
          >
            <GearSix size={20} />
          </Link>
        )}
        <UserOrgMenu />
      </Space>
    </Header>
  );
}
